import request from '../../axios';

export const patchPostLike = async (payload: IPostLikePayload) => {
  const {data}: {data: IResponse} = await request.patch(
    `/api/v2/store/liking-view`,
    payload,
  );
  return data;
};
